export default __webpack_public_path__ + "static/images/Mina_5.png";